import { createContext, useContext } from 'react';
import { useLocation, type Location } from 'react-router-dom';

/**
 * The location *this screen* was mounted with — frozen for the life of the
 * screen even while it animates away.
 *
 * During a route transition the NavStack keeps the outgoing screen mounted, but
 * the router's `useLocation()` has already advanced to the destination. A screen
 * that reads the live location mid-exit would briefly see the wrong route (and,
 * e.g., save/restore scroll under the wrong key). NavStack publishes the
 * per-layer location here so anything inside a screen can read a stable value;
 * outside a transition it falls back to the live location.
 */
const ScreenLocationContext = createContext<Location | null>(null);

export const ScreenLocationProvider = ScreenLocationContext.Provider;

export function useScreenLocation(): Location {
  const frozen = useContext(ScreenLocationContext);
  const live = useLocation();
  return frozen ?? live;
}
